import React, { useEffect, useRef, useState } from "react";
import { PatternFormat } from "react-number-format";
import { BsyUtils } from "../../utils/Utils";
import BsyDatePicker from "../BsyDatePicker";
import BsyMsgBubble from "../BsyMsgBubble";
import { BsyWidget } from "../BsyWidget";
import "./index.css";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import toObject from "dayjs/plugin/toObject";
import { useForkRef } from "../../utils/useForkRef";
import { dayjsUtils } from "../../utils/dayjsUtils";

dayjs.extend(toObject);
dayjs.extend(customParseFormat);
export default class BsyDateTime extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-datetime",
      triggerIcon: "icon-widget-datetime",
      startDate: null,
      endDate: null,
      allowBlank: !0,
      format: "yyyy-MM-dd",
      onAfterEdit: null,
      timeMode: "now", //动态时间的时候，默认取什么值  now 当前时分秒 min 0时0分0秒0毫秒  max 23小时59分59秒999毫秒
      edge: {
        width: 240,
        height: 315,
      },
      ...props,
    });
    this.value = this.setOffsetValue(this.options.value);
    this.state = {
      value: this.value,
    };
    this.options.format = this.options.format || props.format || "yyyy-MM-dd";

    if (this.value) {
      this.realValue = BsyUtils.date2Str(dayjsUtils.timeToTZ(new Date(this.value)), this.options.format);
    }

    this.input = React.createRef();
    this.element = React.createRef();
    this.viewMode = this._initViewMode();
    this.std = this._initStartDate(
      this._dynamicTime(this.options.startDate),
      this.viewMode
    );
    this.edd = this._initEndDate(
      this._dynamicTime(this.options.endDate),
      this.viewMode
    );
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.value = event.target.value ? event.target.value.trim() : "";
    this.setState({ value: this.value });
  }

  _dynamicTime = (time) => {
    if (!time) {
      return null;
    }
    if (!BsyUtils.isString(time)) return time;

    //2020-10-1 直接返回
    if (time.indexOf("-") > 2) {
      return time;
    }
    if (time.indexOf("/") > 2) {
      return time;
    }
    if (time.indexOf(" ") > 2) {
      return time;
    }
    if (time.indexOf(":") > 2) {
      return time;
    }

    //处理 +1s +1m +1h  -1s -1m -1h
    let val = parseInt(time);
    let dt = 0;
    if (time.indexOf("s") > -1) {
      dt = val * 1000;
    } else if (time.indexOf("m") > -1) {
      dt = val * 60000;
    } else if (time.indexOf("h") > -1) {
      dt = val * 3600000;
    } else if (time.indexOf("d") > -1) {
      dt = val * 3600000 * 24;
    } else {
      return time;
    }
    let tt = new Date().getTime();

    let type = time.charCodeAt(0);
    if (type === 43) {
      tt += dt;
    } else if (type === 45) {
      tt -= dt;
    }
    return tt;
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    //防止多次重复 setState
    let props = {};
    if (nextProps.value !== this.state.value) {
      this.value = this.setOffsetValue(nextProps.value);
      props.value = this.value;
    }

    if (nextProps.startDate !== this.options.startDate) {
      this.options.startDate = nextProps.startDate;
      this.std = this._initStartDate(
        this._dynamicTime(this.options.startDate),
        this.viewMode
      );
    }
    if (nextProps.endDate !== this.options.endDate) {
      this.options.endDate = nextProps.endDate;
      this.edd = this._initEndDate(
        this._dynamicTime(this.options.endDate),
        this.viewMode
      );
    }
    if (!BsyUtils.isObjectEmpty(props)) {
      this.setState({
        ...props,
      });
    }
  }

  _onTriggerClick = (event) => {
    const { style, timeMode } = this.options;
    let that = this;
    const format = that.props.format || this.options.format || "yyyy-MM-dd";

    let nowTime = new Date();
    if (!that.state.value) {

      // 防止跨天
      nowTime = dayjsUtils.timeToTZ(nowTime)
      switch (timeMode) {
        case "max": {
          nowTime = BsyUtils.getFormatDateEnd(nowTime, format);
          break;
        }
        case "min": {
          nowTime = BsyUtils.getFormatDateStart(nowTime, format);
          break;
        }
        default: {
          nowTime = BsyUtils.getFormatDate(nowTime, format);
          break;
        }
      }
      const ct = dayjsUtils.timeToLocal(nowTime, format);
      nowTime = ct.date;
    }

    BsyMsgBubble({
      anchor: event.currentTarget,
      contentHTML: (ref) => {
        that.showMsg = ref;
        return (
          <BsyDatePicker
            ref={(el) => (that.datePicker = el)}
            customCls={style ? style.theme.name : ""}
            viewMode={that.viewMode}
            startDate={that.std}
            endDate={that.edd}
            format={format}
            date={dayjsUtils.timeToTZ(that.state.value ? new Date(that.state.value) : nowTime)}
            onDateUpdate={(date, closeFloat) => {
              // 暂时固定写死，后面代码要根据后端返回的转换
              if (date) {
                const djObject = dayjsUtils.timeToLocal(date);
                this.value = djObject.date.getTime();
                this.realValue = BsyUtils.date2Str(djObject.date, format);
              } else {
                this.value = null;
                this.realValue = "";
              }
              that.setState({ value: this.value }, () => {
                if (closeFloat) ref.closeAlter();
              });
            }}
            onDateClear={() => {
              that.value = null;
              this.realValue = "";
              that.setState({ value: null }, () => {
                ref.closeAlter();
              });
            }}
          />
        );
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: 268,
      width: "auto",
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function () {
        that.showMsg = undefined;
        that.datePicker = null;
        setTimeout(() => {
          BsyUtils.applyFunc(
            that,
            that.props.onStopEdit,
            [that.value, null, that],
            !1
          );
          that.props.onClose?.(that.value);
        }, 0);
        return !1;
      },
    });
  };


  getValue = () => {
    return this.value;
  };

  getRealValue = () => {
    return this.realValue;
  };

  checkValidate = () => {
    var a = this.options,
      b = !0;
    this.setInvalidateTypeText("");
    if (!a.allowBlank) {
      b = !BsyUtils.isObjectEmpty(this.value);
    }

    if (!b) {
      this.setInvalidateTypeText(React.language("item.required"));
    }
    return b;
  };

  _initViewMode = () => {
    let a = this.options,
      b = 1;

    switch (a.format) {
      case "yyyy-MM": {
        b = 0;
        return b;
      }
      case "yyyy": {
        b = -1;
        return b;
      }
      default: {
        // a.format = '';
      }
    }
    return (
      a.format.match(/[YyMDd]/)
        ? a.format.match(/[Dd]/)
          ? a.format.match(/[Hhms]/) && (b = 3)
          : (b = 0)
        : (b = a.format.match(/s/) ? 2 : 4),
      b
    );
  };
  _initStartDate = (a, b) => {
    if (!a) return null;
    let c = new Date(a);
    switch (b) {
      case 0:
        return new Date(c.getFullYear(), c.getMonth(), 1, 0, 0, 0);
      case 1:
        return new Date(c.getFullYear(), c.getMonth(), c.getDate(), 0, 0, 0);
      case 2:
        let d = new Date();
        return d.setHours(0), d.setMinutes(0), d.setSeconds(0), d;
      case 3:
        return new Date(c.getFullYear(), c.getMonth(), c.getDate(), 0, 0, 0);
      default:
        return c;
    }
  };

  _initEndDate = (a, b) => {
    if (!a) return null;
    let c = new Date(a);
    switch (b) {
      case 0:
        return new Date(
          c.getFullYear(),
          c.getMonth(),
          c.getMonthDays(),
          23,
          59,
          59
        );
      case 1:
        return new Date(c.getFullYear(), c.getMonth(), c.getDate(), 23, 59, 59);
      case 2:
        let d = new Date();
        return d.setHours(23), d.setMinutes(59), d.setSeconds(59), d;
      case 3:
        return new Date(c.getFullYear(), c.getMonth(), c.getDate(), 23, 59, 59);
      default:
        return c;
    }
  };

  setOffsetValue = (a) => {
    let b = this.options;
    if (BsyUtils.isNull(a)) return "";

    let c = null;
    //为兼容IOS系统,安装IOS需要使用标准的时间格式 2018-08-08T05:20:00Z
    //普通用户在拼接日期的时候一般格式为   2018-08-08 05:20:00 需要特殊处理，IOS默认支持  2018/08/08 05:20:00 格式的日期
    a =
      BsyUtils.isString(a) && a.indexOf("T") === -1 ? a.replace(/-/g, "/") : a;
    c = "today" === a ? new Date() : new Date(a);

    if (c) {
      // 防止跨天
      c = dayjsUtils.timeToTZ(c);
      c = BsyUtils.getFormatDate(c, b.format);
      c = dayjsUtils.timeToLocal(c).date;
    }

    let d = c.getTime();
    if (isNaN(d)) {
      return null;
    } else {
      return d;
    }
  };

  setValue = (a) => {
    this.value = this.setOffsetValue(a);
    if (this.value) {
      this.realValue = BsyUtils.date2Str(dayjsUtils.timeToTZ(new Date(this.value)), this.options.format);
    }
    this.setState({
      value: this.value,
    });
  };

  renderDisablePane = () => {
    const { format } = this.options;
    const { value } = this.state;
    let strvalue = value
      ? BsyUtils.date2Str(dayjsUtils.timeToTZ(value), format || this.props.format)
      : "";
    return (
      <div
        className="bsy_form_item_disable"
        data-watermark={React.language("content.empty")}
        title={strvalue}
        ref={this.element}
      >
        {strvalue}
      </div>
    );
  };

  render() {
    const { cssName, css, format, waterMark, hint } = this.options;
    const { value } = this.state;

    if (!this.isEnabled()) {
      return this.renderDisablePane();
    }

    return (
      <div className={cssName} style={css}>
        <div
          className="showContent"
          ref={this.element}
          onClick={(e) => {
            if (!this.showMsg) {
              this._onTriggerClick(e);
            }
            e.stopPropagation();
            this.input.current?.focus();
          }}
          onBlur={(e) => {
            e.currentTarget.classList.remove("focus");
            this.input.current?.blur();
          }}
          onFocus={(e) => {
            e.currentTarget.classList.add("focus");
            this.input.current?.focus();
            if (!this.showMsg) {
              this._onTriggerClick(e);
            }
          }}
          tabIndex="-1"
        >
          <DateTimeFormatInput
            ref={this.input}
            format={format || this.props.format}
            className={"value-text format-input"}
            placeholder={waterMark || hint}
            value={value ? dayjsUtils.timeToTZ(value) : null}
            onChange={(v) => {
              this.datePicker?.updateDate(v);
              const object = dayjsUtils.timeToLocal(v);
              this.value = object.date.getTime();
              this.realValue = object.dateStr;
              this.setState({
                value: this.value,
              });
            }}
          />
          <div
            className={
              "iconSelect " +
              (!BsyUtils.isObjectEmpty(value) ? "has-value" : "")
            }
          >
            <i className="widget-icon icon-widget-datetime"> </i>
            {!BsyUtils.isObjectEmpty(value) ? (
              <i
                className="widget-icon icon-dingding-guide-close"
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  this.value = null;
                  this.realValue = "";
                  this.setState(
                    {
                      value: null,
                    },
                    () => {
                      this.props.onStopEdit(this.state.value, null, this);
                    }
                  );
                }}
              ></i>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

function convertToTwoDigitNumber(input) {
  const number = parseInt(input, 10);
  if (isNaN(number) || number < 0) {
    return String(input);
  }
  return (number < 10 ? "0" : "") + String(number);
}

function extractTimeValues(timeString) {
  const objs = {};
  const [date, time] = timeString.split(" ");
  if (date) {
    const [year, month, day] = date.split("-");
    objs.year = String(year);
    objs.month = month ? convertToTwoDigitNumber(month) : undefined;
    objs.date = day ? convertToTwoDigitNumber(day) : undefined;
  }
  if (time) {
    const [hour, minute, second] = time.split(":");
    objs.hour = hour ? convertToTwoDigitNumber(hour) : undefined;
    objs.minute = minute ? convertToTwoDigitNumber(minute) : undefined;
    objs.second = second ? convertToTwoDigitNumber(second) : undefined;
  }
  return objs;
}

const formatToLevel = (format = "YYYY-MM-DD HH:mm:dd") => {
  if (format === "YYYY") {
    return 1;
  }
  if (format === "YYYY-MM") {
    return 2;
  }
  if (format === "YYYY-MM-DD") {
    return 3;
  }
  if (format === "YYYY-MM-DD HH") {
    return 4;
  }
  if (format === "YYYY-MM-DD HH:mm") {
    return 5;
  }
  return 6;
};

function dataObjToDateStr(dataObj, format) {
  const formatLevel = formatToLevel(format);
  const { year, month, date, hour, minute, second } = dataObj;
  if (formatLevel === 1) {
    return year;
  }
  if (formatLevel === 2) {
    return `${year}-${month}`;
  }
  if (formatLevel === 3) {
    return `${year}-${month}-${date}`;
  }
  if (formatLevel === 3) {
    return `${year}-${month}-${date} ${hour}`;
  }
  if (formatLevel === 3) {
    return `${year}-${month}-${date} ${hour}:${minute}`;
  }
  return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
}

const dateValid = function (dateStr, format = "YYYY-MM-DD HH:mm:dd") {
  const { year, month, date, hour, minute, second } =
    extractTimeValues(dateStr);
  const formatLevel = formatToLevel(format);
  if (!year) {
    return {
      year: true,
    };
  }
  const validObj = {};
  if (year && (Number(year) < 1001 || Number(year) > 9999)) {
    validObj.year = true;
  }
  if (month && (Number(month) < 1 || Number(month) > 12)) {
    validObj.month = true;
  } else if (formatLevel > 1 && !month) {
    validObj.month = true;
  }
  if (dateStr.length >= "YYYY-mm-dd".length) {
    const endDate = dayjs(`${year}-${month}`).endOf("month").date();
    if (date && (Number(date) < 1 || Number(date) > endDate)) {
      validObj.date = true;
    }
  }
  if (formatLevel > 2 && !date) {
    validObj.date = true;
  }

  if (hour && (Number(hour) < 0 || Number(hour) > 23)) {
    validObj.hour = true;
  } else if (formatLevel > 3 && !hour) {
    validObj.hour = true;
  }
  if (minute && (Number(minute) < 0 || Number(minute) > 59)) {
    validObj.minute = true;
  } else if (formatLevel > 4 && !minute) {
    validObj.minute = true;
  }
  if (second && (Number(second) < 0 || Number(second) > 59)) {
    validObj.second = true;
  } else if (formatLevel > 5 && !second) {
    validObj.second = true;
  }
  if (Object.keys(validObj).length) {
    return validObj;
  }
  return undefined;
};
const dateStrErrorConversion = function (dateStr, format) {
  const dateValids = dateValid(dateStr, format);
  const formatLevel = formatToLevel(format);
  const { year, month, date, hour, minute, second } =
    extractTimeValues(dateStr);
  const timeStrs = [];
  if (dateValids) {
    if (dateValids.year) {
      timeStrs.push("1001");
    } else {
      timeStrs.push(year);
    }
    if (dateValids.month) {
      timeStrs.push("01");
    } else {
      month && timeStrs.push(month);
    }
    if (dateValids.date) {
      timeStrs.push("01");
    } else {
      date && timeStrs.push(date);
    }
    if (dateValids.hour) {
      timeStrs.push("00");
    } else {
      hour && timeStrs.push(hour);
    }
    if (dateValids.minute) {
      timeStrs.push("00");
    } else {
      minute && timeStrs.push(minute);
    }
    if (dateValids.second) {
      timeStrs.push("00");
    } else {
      second && timeStrs.push(second);
    }
    return [
      timeStrs.slice(0, formatLevel > 3 ? 3 : formatLevel).join("-"),
      formatLevel > 3 ? timeStrs.slice(3, formatLevel).join(":") : undefined,
    ]
      .filter(Boolean)
      .join(" ");
  }
  return dateStr;
};
/**
 *
 * @param date string|Date|number|day
 * @param format
 * @returns {number}
 */
function dateStrValueOf(date, format) {
  const level = formatToLevel(format);
  const types = ["", "year", "month", "date", "hour", "minute", "second"];
  if (typeof date === "object" && date.$isDayjsObject) {
    return date.startOf(types[level]).valueOf();
  }
  if (date instanceof Date || typeof date === "number") {
    return dayjs(date).startOf(types[level]).valueOf();
  }
  return dayjs(date, format).startOf(types[level]).valueOf();
}

function formatsConvert(format) {
  if (format === "yyyy") {
    return {
      patternFormat: "####",
      dateFormat: "YYYY",
    };
  }
  if (format === "yyyy-MM") {
    return {
      patternFormat: "####-##",
      dateFormat: "YYYY-MM",
    };
  }
  if (format === "yyyy-MM-dd") {
    return {
      patternFormat: "####-##-##",
      dateFormat: "YYYY-MM-DD",
    };
  }
  if (format === "yyyy-MM-dd HH") {
    return {
      patternFormat: "####-##-## ##",
      dateFormat: "YYYY-MM-DD HH",
    };
  }
  if (format === "yyyy-MM-dd HH:mm") {
    return {
      patternFormat: "####-##-## ##:##",
      dateFormat: "YYYY-MM-DD HH:mm",
    };
  }
  return {
    patternFormat: "####-##-## ##:##:##",
    dateFormat: "YYYY-MM-DD HH:mm:ss",
  };
}

const DateTimeFormatInput = React.forwardRef(function (props, ref) {
  const inputRef = useRef();
  const fokRef = useForkRef(inputRef, ref);
  const isActiveUpdate = useRef(0);
  const {
    format = "yyyy-MM-dd HH:mm:ss",
    value,
    disabled,
    onChange,
    onBlur,
    onFocus,
    className,
    placeholder,
  } = props;
  const _formats = formatsConvert(format);
  const [dateStr, setDateStr] = useState(
    value ? dayjs(value).format(_formats.dateFormat) : ""
  );
  useEffect(() => {
    if (isActiveUpdate.current === 0) {
      isActiveUpdate.current = 1;
    }
    if (isActiveUpdate.current === 1) {
      setDateStr(
        value && dayjs(value).isValid()
          ? dayjs(value).format(_formats.dateFormat)
          : ""
      );
    }
    if (isActiveUpdate.current === -1) {
      isActiveUpdate.current = 0;
    }
  }, [value]);
  const timeValueSplitPatternFormat = (values) => {
    let endIndex = (() => {
      let a = 0;
      for (let i = 0; i < _formats.patternFormat.length; i++) {
        if (_formats.patternFormat[i] === "#") {
          a++;
        }
        if (a >= values.value.length) {
          return i + 1;
        }
      }
    })();
    return values.formattedValue.slice(0, endIndex);
  };
  const validDate = (values) => {
    const { selectionStart } = inputRef.current || {};
    let endIndex = timeValueSplitPatternFormat(values).length;
    if (endIndex !== selectionStart) {
      return dayjs(values.formattedValue, _formats.dateFormat, true).isValid();
    } else {
      if (dayjs(values.value).isValid()) {
        if (values.value.length > 2 && values.value.length % 2 === 0) {
          return true;
        }
      }
      return false;
    }
  };
  return (
    <PatternFormat
      className={className}
      disabled={disabled}
      format={_formats.patternFormat}
      placeholder={placeholder}
      value={dateStr}
      getInputRef={fokRef}
      displayType="input"
      onChange={(event) => {
        isActiveUpdate.current = 0;
        setDateStr(event.target.value);
      }}
      onValueChange={(values, sourceInfo) => {
        setTimeout(() => {
          const dateFormatStr = timeValueSplitPatternFormat(values);
          const vals = dateValid(dateFormatStr, _formats.dateFormat);
          if (validDate(values) && isActiveUpdate.current === 0) {
            const dateObject = extractTimeValues(dateFormatStr);
            let newDate = dayjs(value || undefined);
            if (values.value.length > 0 && vals?.year !== true) {
              newDate = newDate.year(dateObject.year);
            }
            if (values.value.length > 4 && vals?.month !== true) {
              newDate = newDate.month(dateObject.month - 1);
            }
            if (values.value.length > 6 && vals?.date !== true) {
              newDate = newDate.date(dateObject.date);
            }
            if (values.value.length > 8 && vals?.hour !== true) {
              newDate = newDate.hour(dateObject.hour);
            }
            if (values.value.length > 10 && vals?.minute !== true) {
              newDate = newDate.minute(dateObject.minute);
            }
            if (values.value.length > 12 && vals?.second !== true) {
              newDate = newDate.second(dateObject.second);
            }
            isActiveUpdate.current = -1;
            onChange?.(dateStrValueOf(newDate, format));
          }
        }, 0);
      }}
      onFocus={onFocus}
      onBlur={(e) => {
        if (dateStr) {
          const str = timeValueSplitPatternFormat({
            formattedValue: dateStr,
            value: dateStr.match(/\d+/g).join(""),
          });
          const vals = dateValid(str, _formats.dateFormat);
          if (vals) {
            const newDateStr = dateStrErrorConversion(str, _formats.dateFormat);
            setDateStr(newDateStr);
            onChange?.(dateStrValueOf(newDateStr, _formats.dateFormat));
          } else {
            const newDateStr = dataObjToDateStr(
              extractTimeValues(str),
              _formats.dateFormat
            );
            onChange?.(dateStrValueOf(newDateStr, _formats.dateFormat));
          }
        }
        onBlur?.(e);
      }}
    />
  );
});
